import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from 'Components/CustomButton/CustomButton'

import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'

import { useMediaQuery, useTheme } from '@mui/material'

export default function ImportData({ fetchOperations }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [file, setFile] = useState(null)

  const {
    handleSubmit,

    reset,

    formState: { errors },
  } = useForm({
    defaultValues: {},
  })

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    reset()
    setOpen(false)
    setFile(null)
  }
  const handleFileChange = (e) => {
    setFile(e.target.files[0])
  }
  const onSubmit = async (data) => {
    const formData = new FormData()
    if (file != null) formData.append('file', file)

    const response = await makePostRequest(
      '/api/Professional/workentrie-import/',

      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (response.status === 200) {
      fetchOperations()
      handleClose()
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>Import</CustomButton>

      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'Black !important' }}>Import</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <input required type="file" accept=".xlsx" onChange={handleFileChange} />
            <br />
            <a href="/workentrie_export.xlsx">Template Excel file</a>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
